module.exports = {
    RECEIVE_HYDROMETRIC_STATION: 'RECEIVE_HYDROMETRIC_STATION',
    RECEIVE_ALL_HYDROMETRIC_STATIONS: 'RECEIVE_ALL_HYDROMETRIC_STATIONS',
    RECEIVE_HYDROMETRY_THRESHOLDS: 'RECEIVE_HYDROMETRY_THRESHOLDS',

    // TODO : Move this list on other global constant file
    MONTHS: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september',
        'october', 'november', 'december'],
    ALL: 'ALL',
    MAX: 'MAX',
    MOY: 'MOY',
    MIN: 'MIN',
    SUM: 'SUM',
    AVERAGE: 'AVERAGE',
    HYDROMETER_HEIGHT_TYPE: 4,
    TIDE_GAUGE_TYPE: 4,

    // ---------------------
    WINDOW: 'window',
    POINT: 'point',
    MOVING: 'moving',
    NEWPOINT: 'newPoint',
    VALIDATION: 'validation',
    HISTORIC: 'historic',
    PURGE: 'purge',
    COMPENSATION: 'compensation',
    CORRECTION: 'correction',
    THRESHOLDS: 'thresholds',
    EVENT: 'event',
    AUTO: 'auto',
    MANUAL: 'manual',
    RESET: 'reset',
    DELETE: 'delete',
    // ---------------------

    // ---------------------
    CITIES: 'cities',
    STATIONS: 'stations',
    STATION: 'station',
    DEPARTMENTS: 'departments',

    HEIGHT_INTEGRATION: 'heightIntegration',
    DEBIT_INTEGRATION: 'debitIntegration',
    WITHPRED: 'withPred',
    DATA: 'DATA',

    STATIONCODES: 'stationCodes',
    TOWNCODES: 'townCodes',
    DEPARTEMENTCODES: 'departmentCodes',

    CAP: 'CAP',
    TTP: 'TTP',
    UDI: 'UDI',
    DEBIT: 'DEBIT',
    HEIGHT: 'HEIGHT',
    ARPEGE: 'ARPEGE',

    STATION_INTEGRATION: 'stationIntegration',
    QUALITE: 'quality',
    VALID_LENGHT: [8, 10, 12],
    BSS: 'BSS',
    CONVENTION_NOMMAGE_1: 10,
    CONVENTION_NOMMAGE_2: 'X',

    IMPORT: 'IMPORT',
    EXPORT: 'EXPORT',
    ALERTE: 'ALERTE',
    CALCUL: 'CALCUL',
    OTHER: 'OTHER',
    DATA_INTEGRATION: 'dataIntegration',
    DATA_NOTHING: 'DATA_NOTHING',
    DATA_REPLACE_HISTO: 'DATA_REPLACE_HISTO',
    DATA_REPLACE_DATA: 'DATA_REPLACE_DATA',
    DATA_REPLACE_RECENT_HISTO: 'DATA_REPLACE_RECENT_HISTO',
    DATA_ADD_NEW_DATA: 'DATA_ADD_NEW_DATA',
    DATA_ADD_LAST_DATA: 'DATA_ADD_LAST_DATA',

    STEPS: {
        TRAITEMENT: 'TRAITEMENT',
        TRAITEMENT_TYPE: 'TRAITEMENT_TYPE',
        TYPE: 'TYPE',
        OPTIONS: 'OPTIONS',
    },


    IMPORT_TYPE: {
        HYDRO_PORTAIL: 'HYDRO',
        LOW_WATER_ONDE: 'lowWater',
        TIDE_GAUGE: 'tidegauge',
        PIEZO: 'piezometry',
        PIEZO_PORTAIL: 'wsAdesPiezo',
        PLUVIO: 'pluviometry',
        PLUVIO_PORTAIL: 'mfObs',
        ERA5: 'era5',
        PLUVIO_EMPRISE: 'pluvioArea',
        METEO_FRANCE_RADAR: 'mfRadar',
        QUALITO: 'QUALITE',
        ADES_QUALITO: 'wsAdesQualito',
        NAIADES: 'surfaceQualitometer',
        OROBNAT: 'tapWater',
        OTHER: 'Autres',
    },

    IMPORT_TYPE_TRAITEMENT: {
        HYDRO_PORTAIL: 'HYDRO',
        PIEZO_PORTAIL: 'wsAdesPiezo',
        PLUVIO_PORTAIL: 'mfObs',
        ERA5: 'era5',
        ADES_QUALITO: 'wsAdesQualito',
        NAIADES: 'surfaceQualitometer',
        OROBNAT: 'tapWater',
        PLUVIO_EMPRISE: 'pluvioArea',
        METEO_FRANCE_RADAR: 'mfRadar',
        LOW_WATER_ONDE: 'lowWater',
        TIDE_GAUGE: 'tidegauge',
        OTHER: 'Autres',
    },

    JOB_TYPES: {
        ADES_QUALITO: 'wsAdesQualito',
        ADES_PIEZO: 'wsAdesPiezo',
        NAIADES: 'surfaceQualitometer',
        HYDRO: 'hydro',
        SYNOP: 'synop',
        OROBNAT: 'tapWater',
        ERA5: 'era5',
        METEO_FRANCE: 'mfObs',
        PLUVIO_EMPRISE: 'pluvioArea',
        METEO_FRANCE_RADAR: 'mfRadar',
        LOW_WATER_ONDE: 'lowWater',
        TIDE_GAUGE: 'tidegauge',
    },

    HYDRO_TYPEID: {
        SAMPLE: -2,
        HEIGHT: 4,
        FLOW: 5,
    },
    HYDRO_L_STORAGE: {
        DISPLAY_MODES_DASHBOARD: 'HYDRO_DISPLAY_MODES_DASHBOARD',
        STATUS_QUALIF_DASHBOARD: 'HYDRO_STATUS_QUALIF_DASHBOARD',
        DISPLAY_MODES_SUIVI: 'HYDRO_DISPLAY_MODES_SUIVI',
        STATUS_QUALIF_SUIVI: 'HYDRO_STATUS_QUALIF_SUIVI',
        TIME_VALIDATION: 'HYDRO_TIME_VALIDATION',
        TIME_OTHER_VALIDATION: 'HYDRO_TIME_OTHER_VALIDATION',
    },

    HYDRO_FOLLOW_L_STORAGE: {
        HIDDEN_THRESHOLDS_HYDROMETRIC_FOLLOW: 'HIDDEN_THRESHOLDS_HYDROMETRIC_FOLLOW',
        STAT_SERIES_HYDROMETRIC_FOLLOW: 'STAT_SERIES_HYDROMETRIC_FOLLOW',
        ACTIVE_YEARS_HYDROMETRIC_FOLLOW: 'ACTIVE_YEARS_HYDROMETRIC_FOLLOW',
        MODEL_CHECK_HYDROMETRIC_FOLLOW: 'MODEL_CHECK_HYDROMETRIC_FOLLOW',
        ASSOCIATED_STATIONS_HYDROMETRIC_FOLLOW: 'ASSOCIATED_STATIONS_HYDROMETRIC_FOLLOW',
        TYPE_ID_HYDROMETRIC_FOLLOW: 'TYPE_ID_HYDROMETRIC_FOLLOW',
        Y_ZOOM_HYDROMETRIC_FOLLOW: 'Y_ZOOM_HYDROMETRIC_FOLLOW',
        MODE_DATE: 'MODE_DATE',
    },

    HYDRO_MEASURE_COTE: {
        NGF: 1,
        HEIGHT: 2,
    },
    HYDRO_DISPLAY_COTE: 'HYDRO_DISPLAY_COTE',
    HYDRO_TAB_DISPLAY_MODES: 'HYDRO_TAB_DISPLAY_MODES',
}